import { makeObservable, observable } from "mobx";
import { ImLabel } from "@whatslly/server-commons/tuvis-messaging/entities/im-labels.entity";

export class IMLabel implements ImLabel {
  _id: string;
  orgId: string;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  name: string;
  constructor(data: ImLabel) {
    this._id = data._id;
    this.orgId = data.orgId;
    this.isDeleted = data.isDeleted;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.name = data.name;

    makeObservable(this, {
      name: observable,
      isDeleted: observable,
    });
  }
}
